import { render, staticRenderFns } from "./ScreenTimeCard.vue?vue&type=template&id=3c173387&scoped=true&"
import script from "./ScreenTimeCard.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeCard.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeCard.vue?vue&type=style&index=0&id=3c173387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c173387",
  null
  
)

export default component.exports